import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=414d5c24&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=414d5c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d5c24",
  null
  
)

export default component.exports